// Staged launch (founder decision, 2026-08-14): Horizon ships in WAVES rather than firing every
// feature at once. A feature's nav tab AND its routes are hidden until its wave goes live - flip its
// flag to `true` when that wave deploys. This is the ONE place the launch surface is controlled:
// App.jsx filters the nav and redirects the routes off these flags. Features NOT listed here are
// always on. Data-driven products (hUSD, individual reserves, vaults, loops) need no flag - they
// simply do not appear until they are deployed/configured on-chain (see each page's liveness gate).
//
//   Wave 1 (launch): money market (Markets), Vaults, staking (Stake), Buyback, Stats (protocol
//                    overview + Liquidations), plus the always-on utilities (Buy, Portfolio,
//                    Leaderboard).
//   Wave 2:          Earn (Guardian Pools).
//   Wave 3:          Multiply (leverage loops).
//   Wave 4:          loopUSD, am-AMM (no tabs yet).
export const FEATURES = {
  earn: false,      // Wave 2 — Guardian Pools
  multiply: false,  // Wave 3 — leverage loops
  husd: false,      // Post-launch SURPRISE (founder call, 2026-08-24) — hidden entirely: no nav tab and
                    // the /husd route redirects home, so a typed URL cannot reach it pre-reveal. Flip to
                    // true (or delete) when hUSD ships. Was briefly "visible but greyed"; reverted to fully hidden.
  // "Auction" (the daily fundraising auction) is ALWAYS VISIBLE — not flag-gated. Its liveness is on-chain
  // instead: AuctionSection reads the auction's input oracle and renders the form GREYED + disabled with a
  // banner ("opens at launch") until genesis wires it at go-live, then it becomes interactive. People can
  // see and understand the auction pre-launch without being able to act (founder call). See
  // HORIZON-AUCTION-SPEC.md. (Replaced the retired oracle-priced mint, entry 342.)
  // ve(3,3) surfaces INSIDE the Stake page (gauge Vote, fees-follow-votes claims, bribe claims). Unlike
  // earn/multiply this gates SECTIONS, not a whole tab — the Stake page itself stays live for lock +
  // pooled-revenue. Flip on with the first real vault gauges so the vote/claim surface is never empty.
  // See VE33-FRONTEND-PLAN.md.
  ve33: true, // LOCAL CLICK-THROUGH ONLY — do NOT commit as true (gates the live pre-launch site)
}

/// True unless a feature is explicitly turned OFF above. Keyed by a tab id without its leading
/// slash (e.g. 'earn', 'multiply'). Anything not present defaults to enabled.
export function isFeatureEnabled(id) {
  return FEATURES[id] !== false
}
